






























































































































































/**
 * @copyright       Palace Resorts
 * @description
 * @author
 * @creationDate
 */
import i18nMessages from "./i18n/messages";
import GlobalMixin from "@/mixins/global";
import dataService from "@/services/proveedoresAPI";
import ResponseData from "@/models/store/ProveedoresTypesData";
import SecctionDocuments from "@/models/store/SecctionDocuments";
import Datatable from "@/components/DatatableRegister/Datatable.vue";
import moment from "moment";
export default GlobalMixin.extend({
  // Asignamos los mensajes del módulo al framework i18n, para el manejo del idioma.
  i18n: i18nMessages,
  components: {
    Datatable,
  },
  props: ["id"],
  data: () => {
    return {
      // GENERAL
      moduleName: "Registro del Proveedor",
      tab: null,
      // PROVEEDOR
      proveedor: {
        userID: "",
        userName: "",
        userProveedorSubcontratacionObra: false,
      },
      nombreProveedor: "",
      // TABS
      totalstps: 0,
      totalrpatronal: 0,
      totalrdocumentos: 0,
      // DOCUMENTOS POR SECCION
      documentosSeccion: [],
      // REGISTRO STPS
      headersRegistroSTPS: [],
      dataTableSTPS: [],
      loadingRSTPS: true,
      registroSTPSIDs: [],
      // REGISTRO PATRONAL
      headersRegistroPatronal: [],
      dataTablePatronal: [],
      loadingPatronal: true,
      // REGISTRO ACTIVIDADES
      headersRegistroActividades: [],
      dataTableActividades: [],
      loadingActividades: true,
      // REGISTRO DOCUMENTOS
      headersRegistroDocumentos: [],
      dataTableDocument: [],
      loadingDocumentos: true,
    };
  },
  methods: {
    // GENERAL
    init() {
      // Obtener datos del proveedor
      this.getID();
      // Documentos por seccion
      this.getDocumentsTypes();
      // Datatable Registro stps
      (this.headersRegistroSTPS = [
        {
          text: "ID",
          align: "start",
          value: "registroSTPSNumero",
        },
        {
          text: "Fecha vigencia inicio",
          value: "registroSTPSVigenciaIni",
          formatter: this.dateFormatted,
        },
        {
          text: "Fecha vigencia fin",
          value: "registroSTPSVigenciaFin",
          formatter: this.dateFormatted,
        },
        { text: "Archivo", value: "registroSTPSBucketKeyFile", file: true },
        {
          text: "Estatus",
          value: "registroSTPSEstatusID",
          template: this.getStatus,
          color: this.getColor,
        },
        { text: "Acciones", value: "actions", sortable: false },
      ]),
        // Obtener registros STPS por proveedor
        this.getTableSTPSRegister();
      // Datatable Registro Patronal
      this.headersRegistroPatronal = [
        {
          text: "ID",
          align: "start",
          value: "registroPatronalNumero",
        },
        {
          text: "N° total de trabajadores",
          value: "registroPatronalTotalTabajadores",
        },
        {
          text: "Matriz",
          value: "registroPatronalMatriz",
          formatter: this.stringFormatted,
        },
        {
          text: "Código postal",
          value: "registroPatronalCodigoP",
        },
        {
          text: "Vigencia inicial",
          value: "registroPatronalVigenciaIni",
          formatter: this.dateFormatted,
        },
        {
          text: "Vigencia fin",
          value: "registroPatronalVigenciaFin",
          formatter: this.dateFormatted,
        },
        { text: "Archivo", value: "registroPatronalBucketKeyFile", file: true },
        {
          text: "Estatus",
          value: "registroPatronalEstatusID",
          template: this.getStatus,
          color: this.getColor,
        },
        { text: "Acciones", value: "actions", sortable: false },
      ];
      // Obtener registros patronales por proveedor
      this.getTableEmployerProvider();
      // Datatable Registro Actividades
      this.headersRegistroActividades = [
        {
          text: "Folio",
          align: "start",
          value: "registroActividadFolio",
        },
        {
          text: "Descripción",
          value: "registroActividadDescripcion",
        },
        {
          text: "Estatus",
          value: "registroActividadEstatusID",
          template: this.getStatus,
          color: this.getColor,
        },
        { text: "Acciones", value: "actions", sortable: false },
      ];
      // Datatable Registro Documentos
      this.headersRegistroDocumentos = [
        {
          text: "Descripción",
          align: "start",
          value: "docDescripcion",
        },

        { text: "Archivo", value: "docBucketKeyFile", file: true },
        {
          text: "Estatus",
          value: "docEstatusID",
          template: this.getStatus,
          color: this.getColor,
        },
        { text: "Acciones", value: "actions", sortable: false },
      ];
    },
    // METODOS GENERICOS 
    dateFormatted(value: string) {
      return moment
        .utc(value)
        .locale("es-mx")
        .format("L");
    },
    stringFormatted(value: string) {
      if (value == "1") {
        return "Si";
      } else {
        return "No";
      }
    },
    getStatus(value: number) {
      switch (value) {
        case 0:
          return "Inactivo";
          break;
        case 1:
          return "Activo - Pendiente por autorizar";
          break;
        case 2:
          return "Autorizado";
          break;
        case 3:
          return "Rechazado";
          break;
        case 4:
          return "Cancelado por el SAT";
          break;
        default:
          return "Inactivo";
          break;
      }
    },
    getColor(value: number) {
      switch (value) {
        case 0:
          return "blue-grey";
          break;
        case 1:
          return "orange";
          break;
        case 2:
          return "green";
          break;
        case 3:
          return "red";
          break;
        case 4:
          return "red";
          break;
        default:
          return "blue-grey";
          break;
      }
    },
    // PROVEEDOR
    getID() {
      dataService.getByID(this.id).then((Response: ResponseData) => {
        this.proveedor = Response.data.data[0];
        this.nombreProveedor =
          (this.proveedor.userID ?? "") +
          " - " +
          (this.proveedor.userName ?? "");
        return "";
      });
    },
    setCheckBoxObra() {
      dataService
        .getProviderObra(
          this.proveedor.userID,
          this.proveedor.userProveedorSubcontratacionObra ? "1" : "0"
        )
        .then((Response: ResponseData) => {})
        .catch((e: Error) => {
          this.proveedor.userProveedorSubcontratacionObra = !this.proveedor
            .userProveedorSubcontratacionObra;
        });
    },
    // DOCUMENTOS POR SECCION
    getDocumentsTypes() {
      dataService
        .getSectionDocuments()
        .then((Response: ResponseData) => {
          this.documentosSeccion = Response.data.data;
          this.documentosSeccion.forEach((doc: any) => {
            if (doc.documentoOrden == 3 && doc.documentoGrupo.length > 0) {
              this.getTableDocumentProvider(doc.documentoGrupo);
            }
          });
        })
        .catch((e: Error) => {});
    },
    getTableDocumentProvider(documentoGrupo: any) {
      documentoGrupo.forEach((doc: any) => {
        dataService
          .getDocumentProvider(this.id, doc.documentoTipoID)
          .then((Response: ResponseData) => {
            this.dataTableDocument[doc.documentoTipoID] = Response.data.data;
            this.totalrdocumentos =
              this.totalrdocumentos + Response.data.data.length;
          })
          .catch((e: Error) => {});
      });
      this.loadingDocumentos = false;
    },
    getVisibleDoc(documento: SecctionDocuments) {
      if (
        !this.proveedor.userProveedorSubcontratacionObra &&
        documento.documentoObra
      ) {
        return false;
      }
      return true;
    },
    // REGISTRO STPS
    async getTableSTPSRegister() {
      dataService
        .getRegisterSTPSProvider(this.id)
        .then((Response: ResponseData) => {
          this.dataTableSTPS = Response.data.data;
          this.totalstps = this.dataTableSTPS.length;
          // Se actualiza la tabla de actividades al inicio
          this.dataTableSTPS.forEach((registroSTPS: any, key: number) => {
            this.registroSTPSIDs[key] = registroSTPS.registroSTPSID;
          });
          this.getTableActivitiesAll();
        })
        .catch((e: Error) => {})
        .finally(() => {
          this.loadingRSTPS = false;
        });
    },
    // Obtener todas las actividades
    getTableActivitiesAll() {
      if (this.registroSTPSIDs.length > 0) {
        this.registroSTPSIDs.forEach((id: number) => {
          dataService
            .getActivitiesSTPS(id)
            .then((Response: ResponseData) => {
              if (Response.data.data.length > 0) {
                Response.data.data.forEach((actividades: any) => {
                  this.dataTableActividades.push(actividades);
                });
              }
            })
            .catch((e: Error) => {})
            .finally(() => {
              this.loadingActividades = false;
            });
        });
      } else {
        this.loadingActividades = false;
      }
    },
    // REGISTRO PATRONAL
    async getTableEmployerProvider() {
      dataService
        .getEmployerProvider(this.id)
        .then((Response: ResponseData) => {
          this.dataTablePatronal = Response.data.data;
          this.totalrpatronal = this.dataTablePatronal.length;
        })
        .catch((e: Error) => {})
        .finally(() => {
          this.loadingPatronal = false;
        });
    },
    // METODOS PARA LOS TOTALES DE DOCUMENTOS
    addItemsRegistroSTPS() {
      this.totalstps = this.totalstps + 1;
    },
    deleteItemsRegistroSTPS() {
      this.totalstps = this.totalstps - 1;
    },
    addItemsRegistroPatronal() {
      this.totalrpatronal = this.totalrpatronal + 1;
    },
    deleteItemsRegistroPatronal() {
      this.totalrpatronal = this.totalrpatronal - 1;
    },
    addItemsDoc() {
      this.totalrdocumentos = this.totalrdocumentos + 1;
    },
    deleteItemsDoc() {
      this.totalrdocumentos = this.totalrdocumentos - 1;
    },
  },
  mounted() {
    this.init();
  },
});
